import type { RouteObject } from "react-router";

/** /favorites is public: a guest's favorites live in this browser until login (D10). */
export const favoritesRoutes: RouteObject[] = [
  {
    path: "favorites",
    handle: { shell: { tab: "favorites", canvas: true } },
    lazy: async () => ({ Component: (await import("./ui/FavoritesPage")).FavoritesPage }),
  },
];
